import React, { useRef, useState } from 'react';
import useBannerStyles from '../../styles/kozelBattle/banner';
import battleVideo from '../../assets/videos/Kozel_battle.webm';

const Banner: React.FC = () => {
    const classes = useBannerStyles();
    const videoRef = useRef<HTMLVideoElement>(null);
    const [playing, setPlaying] = useState(false);

    const handlePlay = () => {
        if (videoRef.current) {
            videoRef.current.play();
            setPlaying(true);
        }
    };

    return (
        <div className={classes.wrapper}>
            <video
                ref={videoRef}
                className={classes.video}
                src={battleVideo}
                playsInline
            />
            {!playing && (
                <>
                    <div className={classes.overlay}>
                        <button
                            className={classes.playButton}
                            onClick={handlePlay}
                            aria-label="Play video"
                        >
                            <span className={classes.playIcon} />
                        </button>
                    </div>
                    <div className={classes.scrollIndicator}>
                        <div className={classes.mouse}>
                            <div className={classes.mouseDot} />
                        </div>
                        <span className={classes.scrollArrow} />
                        <p className={classes.scrollText}>Descoperă provocarea anului</p>
                    </div>
                </>
            )}
        </div>
    );
};

export default Banner;